<template>
  <Section>
    <template v-slot:section-header>
      <h5 class="header-title m-0">แบนเนอร์กิจกรรม</h5>
    </template>
    <template v-slot:section-body>
      <div class="banner-editor-split-view row">
        <div
          class="editor-preview-container mb-3 col-lg-8"
          v-if="activityBanner">
          <div class="preview-header-container">
            <h5 class="name"><i class="fas fa-edit"></i> แก้ไขแบนเนอร์</h5>
            <BackgroundImageChooser
              @update:image="(desktopBanner) => onUpdateValue({ desktopBanner })">
              <span slot="button-text">เปลี่ยนภาพแบนเนอร์</span>
            </BackgroundImageChooser>
          </div>
          <div
            class="element-container">
            <div class="image-container" :class="[{ 'img-empty': !desktopBanner}, 'desktop-banner']">
              <img
                class="image"
                v-if="desktopBanner"
                :src="desktopBanner" />
              <div class="empty-container" v-if="!desktopBanner">
                <div class="detail">ไม่มีภาพแบนเนอร์</div>
              </div>
            </div>
          </div>
          <small class="suggested-size">ขนาดที่เหมาะสม 970x250</small>
          <div class="preview-header-container header-mobile">
            <h5 class="name"><i class="fas fa-mobile-alt"></i> แก้ไขแบนเนอร์สำหรับแสดงผลบนมือถือ</h5>
            <BackgroundImageChooser
              @update:image="(mobileBanner) => onUpdateValue({ mobileBanner })">
              <span slot="button-text">เปลี่ยนภาพแบนเนอร์</span>
            </BackgroundImageChooser>
          </div>
          <div
            class="element-container mobile-size">
            <div class="image-container" :class="[{ 'img-empty': !mobileBanner}, 'mobile-banner']">
              <img
                class="image"
                v-if="mobileBanner"
                :src="mobileBanner" />
              <div class="empty-container" v-if="!mobileBanner">
                <div class="detail">ไม่มีภาพแบนเนอร์</div>
              </div>
            </div>
          </div>
          <small class="suggested-size">ขนาดที่เหมาะสม 336x280</small>
        </div>
        <div
          class="col-lg-4 mt-1"
          v-if="activityBanner">
          <div class="row">
            <div class="col-md-12">
              <FormGroup>
                <h5 class="name">ลิงก์</h5>
                <input
                  type="text"
                  class="form-control"
                  :value="bannerLink"
                  @change="(event) => onUpdateValue({ link: { ...activityBanner.link, url: event.target.value }})"/>
                <div class="form-check form-check-inline">
                  <input
                    id="checkBoxNewTab"
                    class="form-check-input"
                    type="checkbox"
                    value="_blank"
                    @change="(event) => onUpdateValue({ link: { ...activityBanner.link, target: event.target.value }})"/>
                  <label
                    class="form-check-label"
                    for="checkBoxNewTab">
                    &nbsp; เปิดลิงก์ในแท็บใหม่
                  </label>
                </div>
              </FormGroup>
              <FormGroup>
                <SplitRangeDateTimePicker
                  :startTime="activityBanner.startPublish"
                  :endTime="activityBanner.endPublish"
                  :startTitle="'เวลาเริ่มเผยแพร่'"
                  :endTitle="'เวลาสิ้นสุดการเผยแพร่'"
                  @update:startTime="(startPublish) => onUpdateValue({ startPublish })"
                  @update:endTime="(endPublish) =>  onUpdateValue({ endPublish })"/>
              </FormGroup>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Section>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import Section from '@/components/Section.vue';
import dateFormetter from '@/utils/dateFormatter';
import FormGroup from '@/components/FormGroup.vue';
// import BannerMixins from '@/pageDesigner/mixins';
// import RangePublishDatePicker from '@/pageDesigner/RangePublishDatePicker.vue';
// import ElementImageContainer from '@/pageDesigner/ElementImageContainer.vue';
import BackgroundImageChooser from '@/pageDesigner/BackgroundImageChooser.vue';
import SplitRangeDateTimePicker from '@/components/SplitRangeDateTimePicker.vue';

// import ChooseRelatedProgramModal from './ChooseRelatedProgramModal.vue';

export default {
  mixins: [dateFormetter],
  components: {
    Section,
    FormGroup,
    // RangePublishDatePicker,
    // ElementImageContainer,
    BackgroundImageChooser,
    SplitRangeDateTimePicker,
    // ChooseRelatedProgramModal,
  },
  data() {
    return {
      // activityBanner: null,
      activityBannerDefaultData: {
        title: '',
        desktopImage: null,
        mobileImage: null,
        link: {
          url: '',
          target: '_blank',
        },
        startPublish: null,
        endPublish: null,
      },
    };
  },
  computed: {
    ...mapState({
      program: (state) => state.programItem.currentProgram,
      activityBannerData: (state) => state.programItem.currentProgram.activityBanner,
    }),
    activityBanner() {
      return this.activityBannerData ? this.activityBannerData : this.activityBannerDefaultData;
    },
    bannerLink() {
      return _.get(this.activityBanner, 'link.url', null);
    },
    desktopBanner() {
      return _.get(this.activityBanner, 'desktopBanner.urls.cover970w250h', null);
    },
    mobileBanner() {
      return _.get(this.activityBanner, 'mobileBanner.urls.cover336w280h', null);
    },
  },
  methods: {
    onUpdateValue(data) {
      this.$store.dispatch('setCurrentProgram', { ...this.program, activityBanner: { ...this.program.activityBanner, ...data } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/themes/components/manage-metadata.scss';
@import '~@/assets/scss/variables.scss';

.element-container {
  display: flex;
  flex: 1;

  .image-container {
    width: 100%;
    padding-top: 56.25%;
    position: relative;
    overflow: hidden;

    .image {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      img {
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: 0;
      }
    }
  }

  .desktop-banner{
    padding-top: 25.77%;
  }

  /* .mobile-size {
    padding-top: 83.33%;
  } */

  .empty-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    color: $gray-400;
    text-align: center;
    font-size: $font-size-sm;
    font-family: $font-family-base;
  }
  .img-empty {
    background-color: $gray-700;
    position: relative;

  }

  &.mobile-size {
    width: 270px;
    .mobile-banner {
      padding-top: 83.33%;
      /* padding-top: 0; */
    }
    .mobile-popup {
      padding-top: 177.78%;
    }
  }
}

</style>
